import React, {useMemo, useCallback} from 'react';
import {ListBoxOptionType} from '@flixbus/honeycomb-react';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {updateFilter} from '@/Pages/Home/store/slice';
import {useCountries} from '@/Pages/Countries/hooks/useCountries';
import CalculationAutocompleteFilter from '../CalculationAutocompleteFilter/CalculationAutocompleteFilter';

const CountriesFilter: React.FC = () => {
  const {countries} = useCountries();
  const dispatch = useAppDispatch();

  const options: ListBoxOptionType[] = useMemo(
    () =>
      (countries ?? [])
        .map(country => ({
          title: country.name,
          value: country.id
        }))
        .sort((c1, c2) => c1.title.localeCompare(c2.title)),
    [countries]
  );

  const handleSelect = useCallback(
    (selectedOptions: ListBoxOptionType[]) => {
      const value = selectedOptions.map(option => option.value as string);
      dispatch(
        updateFilter({
          field: 'countryIds',
          value
        })
      );
    },
    [dispatch]
  );

  return (
    <CalculationAutocompleteFilter
      label="Countries"
      options={options}
      handleSelect={handleSelect}
    />
  );
};

export default React.memo(CountriesFilter);
